<template>
  <div class="page-title">
    <h1>{{ title }}</h1>
    <p v-if="subtitle">{{ subtitle }}</p>
  </div>
</template>

<script setup lang="ts">
defineProps({
  title: {
    type: String,
    required: true,
  },
  subtitle: {
    type: String,
    default: "",
  },
});
</script>

<style scoped lang="less">
.page-title {
  text-align: center;
  margin-bottom: 32px;

  h1 {
    color: @grey-85;
    font-size: @heading-5-size;
    margin: 0;

    @media (max-width: @screen-sm) {
      font-size: @heading-6-size;
    }
  }

  p {
    color: @grey-45;
    font-size: @font-size-base;
    margin: 8px 0 0;

    @media (max-width: @screen-sm) {
      font-size: @font-size-sm;
    }
  }
}
</style>
